import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AddBeneficiaryComponent } from '@app/modules/banking/modules/owner/components/add-beneficiary/add-beneficiary.component';
import { AddPrimaryAccountsComponent } from '@app/modules/banking/modules/owner/components/virtual-account-setup/primary-info/add-primary-accounts/add-primary-accounts.component';
import { KycDocumentsComponent } from '@app/modules/banking/modules/owner/components/virtual-account-setup/primary-info/kyc-documents/kyc-documents.component';
import { PersonalInfoComponent } from '@app/modules/banking/modules/owner/components/virtual-account-setup/primary-info/personal-info/personal-info.component';
import { PrimaryInfoComponent } from '@app/modules/banking/modules/owner/components/virtual-account-setup/primary-info/primary-info.component';
import { BreadcrumbComponent } from '@shared/breadcrumb/breadcrumb.component';
import {
  ColumnsChartComponent,
  DonutChartComponent,
  EmptyChartComponent,
  LineChartComponent,
  MixedChartComponent,
  RadialbarChartComponent,
  SemiDonutChartComponent,
  TreemapChartComponent
} from '@shared/chart';
import { DataNotFoundComponent } from '@shared/data-not-found/data-not-found.component';
import { DateRangePickerComponent } from '@shared/date-range-picker/date-range-picker.component';
import { AutoHeightDirective } from '@shared/directives/auto-height.directive';
import { SkipContentDirective } from '@shared/directives/skip-content.directive';
import { FooterComponent } from '@shared/footer/footer.component';
import { InvoicePaginationComponent } from '@shared/invoice-pagination/invoice-pagination.component';
import { NavbarComponent } from '@shared/navbar/navbar.component';
import { NotFoundComponent } from '@shared/not-found/not-found.component';
import {
  BsDatepickerModule,
  NgSelectModule,
  PaginationModule,
  PmdAccordionModule,
  PmdAlertModule,
  PmdButtonModule,
  PmdButtonToggleModule,
  PmdCardModule,
  PmdCheckboxModule,
  PmdCollapseModule,
  PmdDropdownModule,
  PmdFormGroupModule,
  PmdModalModule,
  PmdNavbarModule,
  PmdPopoverModule,
  PmdProgressbarModule,
  PmdRadioButtonModule,
  PmdRippleEffectModule,
  PmdSidebarModule,
  PmdSwitchModule,
  PmdTabsModule,
  PmdTooltipModule,
  RatingModule
} from '@shared/propeller';
import { SidebarComponent } from '@shared/sidebar/sidebar.component';
import { PmdFixedHeaderModule } from '@shared/table-header-fixed/fixed-header.module';
import { TableLoaderComponent } from '@shared/table-loader/table-loader.component';
import { ZoomComponent } from '@shared/zoom/zoom.component';
import { AngularDraggableModule } from 'angular2-draggable';
import { NgApexchartsModule } from "ng-apexcharts";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { JoyrideModule } from 'ngx-joyride';
import { ConfirmDetailModalComponent } from './confirm-detail-modal/confirm-detail-modal.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { BlockCopyPasteDirective } from './directives/block-copy-paste.directive';
import { UppercaseDirective } from './directives/upper-case.directive';
import { FillCompanyDetailsComponent } from './fill-company-details/fill-company-details.component';
import { InvoiceExtractionComponent } from './invoice-extraction/invoice-extraction.component';
import { KycStatusComponent } from './kyc-status/kyc-status.component';
import { PdfZoomReviewComponent } from './pdf-zoom-review/pdf-zoom-review.component';
import { PdfZoomComponent } from './pdf-zoom/pdf-zoom.component';
import { RemovePrefixPipe } from './pipes/file-format.pipe';
import { FilesizePipe } from './pipes/filesize.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TextDifferencePipe } from './pipes/text-difference.pipe';
import { ValidateInvoiceDatePipe } from './pipes/validate-invoice-date.pipe';
import { PlanExpiryBannerComponent } from './plan-expiry-banner/plan-expiry-banner.component';
import { SubMenuOptionsComponent } from './propeller/sub-menu-options/sub-menu-options.component';
import { SidebarSubmenuComponent } from './sidebar-submenu/sidebar-submenu.component';



@NgModule({
  declarations: [
    BreadcrumbComponent,
    SkipContentDirective,
    AutoHeightDirective,
    FooterComponent,
    NavbarComponent,
    ZoomComponent,
    NotFoundComponent,
    SafeHtmlPipe,
    SidebarComponent,
    SidebarSubmenuComponent,
    ConfirmDetailModalComponent,
    DataNotFoundComponent,
    DateRangePickerComponent,
    TableLoaderComponent,
    InvoicePaginationComponent,
    DonutChartComponent,
    MixedChartComponent,
    SemiDonutChartComponent,
    RadialbarChartComponent,
    TreemapChartComponent,
    ColumnsChartComponent,
    EmptyChartComponent,
    LineChartComponent,
    ValidateInvoiceDatePipe,
    PdfZoomComponent,
    AutoFocusDirective,
    FilesizePipe,
    RemovePrefixPipe,
    TextDifferencePipe,
    BlockCopyPasteDirective,
    UppercaseDirective,
    KycStatusComponent,
    KycDocumentsComponent,
    PrimaryInfoComponent,
    PersonalInfoComponent,
    AddPrimaryAccountsComponent,
    AddBeneficiaryComponent,
    FillCompanyDetailsComponent,
    PlanExpiryBannerComponent,
    SubMenuOptionsComponent,
    InvoiceExtractionComponent,
    PdfZoomReviewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PmdNavbarModule,
    PmdSidebarModule,
    PmdCardModule,
    PmdCollapseModule.forRoot(),
    PmdDropdownModule.forRoot(),
    PmdFormGroupModule.forRoot(),
    PmdPopoverModule.forRoot(),
    PmdButtonModule,
    PmdTabsModule.forRoot(),
    PmdSwitchModule,
    PmdAccordionModule.forRoot(),
    PmdCheckboxModule,
    PmdTooltipModule.forRoot(),
    PmdAlertModule.forRoot(),
    PmdRippleEffectModule,
    PmdModalModule.forRoot(),
    PmdButtonToggleModule.forRoot(),
    PmdRadioButtonModule,
    PmdProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgSelectModule,
    PaginationModule.forRoot(),
    NgApexchartsModule,
    PdfViewerModule,
    DragDropModule,
    AngularDraggableModule,
    JoyrideModule,
    PdfJsViewerModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    BreadcrumbComponent,
    SkipContentDirective,
    AutoHeightDirective,
    FooterComponent,
    NavbarComponent,
    ZoomComponent,
    NotFoundComponent,
    SafeHtmlPipe,
    SidebarComponent,
    SidebarSubmenuComponent,
    DataNotFoundComponent,
    DateRangePickerComponent,
    TableLoaderComponent,
    InvoicePaginationComponent,
    DonutChartComponent,
    MixedChartComponent,
    SemiDonutChartComponent,
    RadialbarChartComponent,
    TreemapChartComponent,
    ColumnsChartComponent,
    EmptyChartComponent,
    LineChartComponent,
    PdfZoomComponent,
    PdfZoomReviewComponent,
    KycStatusComponent,
    AddBeneficiaryComponent,
    KycDocumentsComponent,
    PersonalInfoComponent,
    PrimaryInfoComponent,
    AddPrimaryAccountsComponent,
    ConfirmDetailModalComponent,
    FillCompanyDetailsComponent,
    PlanExpiryBannerComponent,
    InvoiceExtractionComponent,
    PmdNavbarModule,
    PmdSidebarModule,
    PmdCardModule,
    PmdCollapseModule,
    PmdDropdownModule,
    PmdFormGroupModule,
    PmdButtonModule,
    PmdTabsModule,
    PmdSwitchModule,
    PmdAccordionModule,
    PmdCheckboxModule,
    PmdTooltipModule,
    PmdAlertModule,
    PmdPopoverModule,
    PmdRippleEffectModule,
    PmdModalModule,
    PmdButtonToggleModule,
    PmdRadioButtonModule,
    PmdProgressbarModule,
    RatingModule,
    BsDatepickerModule,
    NgSelectModule,
    ValidateInvoiceDatePipe,
    PdfViewerModule,
    AutoFocusDirective,
    PmdFixedHeaderModule,
    DragDropModule,
    AngularDraggableModule,
    FilesizePipe,
    RemovePrefixPipe,
    TextDifferencePipe,
    BlockCopyPasteDirective,
    UppercaseDirective,
    JoyrideModule,
    NgApexchartsModule,
    SafeHtmlPipe,
    PdfJsViewerModule
  ]
})
export class SharedModule { }